export const MAX_COMMENT_TEXT_LENGTH = 1500;
export const MAX_COMMENT_HTML_LENGTH = 2000;
